// src/components/padrekko/qc/ActionError.jsx
//
// A refused act, in the server's words: its `error`, and its `detail` beneath
// when there is one. The store's handoff acts (useQcStore: releaseCase,
// shareCase, revokeShare, advanceStage) never return a blank error, so this
// renders whatever they hand it (REM-576; REM-629's lesson).

import { AlertCircle } from "lucide-react";

export default function ActionError({ failure }) {
  if (!failure) return null;
  const error = failure.error
    || (failure.status ? `Failed (HTTP ${failure.status})` : "Failed");
  return (
    <div className="flex items-start gap-1.5 text-[11px] text-red-300 leading-snug" role="alert" data-qc-action-error>
      <AlertCircle size={11} className="mt-0.5 shrink-0" />
      <div className="min-w-0">
        <div>{error}</div>
        {failure.detail && <div className="text-red-300/80">{failure.detail}</div>}
      </div>
    </div>
  );
}
